<template>
  <div class="Users">
      <div class="p-2 rounded">
        <!-- Header -->
        <div class="row">
          <div class="col-md-5">
            <div class="input-group flex-nowrap">
              <input class="btn bg-transparent text-start text-white fw-light fs-5 rounded" style="width: 120px; margin-top: 0px; letter-spacing: 3px; cursor: default;" type="text" value="Users" readonly>
              <button class="btn btn-kraken fs-5 me-1 w-25" :disabled="gettingUsers || processing" @click="getUsers">
                <i class="fa-solid fa-refresh" :class="{'fa-spin': gettingUsers}"></i>
              </button>
              <select class="btn btn-kraken fs-5 fw-light w-100" v-model="user" :disabled="gettingUsers || processing" @change="setUserMain">
                <option :value="duser">Select a user...</option>
                <option v-for="(_user, i) in users" v-bind:key="i+1" :value="_user">{{_user.username}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-1"></div>
          <div class="col-md-6">
            <div v-show="!processing">
              <div class="input-group flex-nowrap">
                <input type="text" class="btn btn-dark w-50 fs-5 me-1 rounded" placeholder="Username" v-model="newuser" style="cursor: text;" :disabled="processing || gettingUsers">
                <input type="text" class="btn btn-dark w-75 fs-5 me-1 rounded" placeholder="E-mail" v-model="newmail" style="cursor: text;" :disabled="processing || gettingUsers">
                <button class="btn btn-kraken fs-5" style="width: 15%;" :class="{'btn-kraken': newuser, 'btn-dark': !newuser}" title="Add User" @click="Newuser" :disabled="processing || !newuser || !newmail || gettingUsers">
                  <i class="fa-solid fa-user" :class="{'fa-beat-fade': processing}"></i>
                  <i class="fa-solid fa-plus" :class="{'fa-beat-fade': processing}"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Sections -->
      <div class="bg-transparent p-2 rounded mt-2" style="height: 587px;">
          <!-- Rest Area -->
          <div v-show="section=='restarea'" class="fs-3 text-white">
            <div style="margin-top: 17%;">
                <i class="fa-solid fa-xl fa-users" :class="{'fa-beat': processing || gettingUsers}"></i>
                <p class="text-white fw-light">{{actionMessage}}</p>
            </div>
          </div>
          <!-- Main -->
          <div v-if="section == 'main'" class="">
            <div class="row">
              <div class="col-md-3">
                <div class="p-2">
                  <div class="input-group flex-nowrap">
                    <button class="btn btn-kraken fs-6 me-1" style="width: 15%">
                      <i class="fa-solid fa-xl fa-user"></i>
                    </button>
                    <input class="btn btn-dark fs-6 fw-light" :value="su.username" style="width: 85%; cursor: text; pointer-events: none;" title="Selected user." type="text" readonly>
                  </div>
                  <div class="input-group flex-nowrap mt-1">
                    <button class="btn btn-kraken fs-6 me-1" style="width: 15%">
                      <i class="fa-solid fa-xl fa-at"></i>
                    </button>
                    <input class="btn btn-dark fs-6 fw-light" v-model="su.email" style="width: 85%; cursor: text;" placeholder="Email" title="Email" type="text">
                  </div>
                  <div class="bg-transparent rounded mt-1">
                    <div class="input-group flex-nowrap" >
                      <button class="btn btn-warning fs-5 me-1" @click="Resetsecret" title="Reset user password." style="width: 33%;">
                        <i class="fa-solid fa-xl fa-arrows-spin"></i>
                      </button>
                      <button class="btn btn-danger fs-5 me-1" @click="Deleteuser" title="Delete user." style="width: 33%;">
                        <i class="fa-solid fa-xl fa-trash"></i>
                      </button>
                      <button class="btn btn-success fs-5" @click="Saveuser" title="Save changes." style="width: 33%;">
                        <i class="fa-solid fa-xl fa-save"></i>
                      </button>
                    </div>
                  </div>
                  <div v-if="!su.blocked" class="text-white fs-5 mt-2">
                      <div>
                        This user is available, to block this user click on the button below.
                      </div>
                      <button class="btn btn-danger fs-5 mt-2" @click="Processuser('block')" title="Block user." style="width: 25%;">
                        <i class="fa-solid fa-xl fa-lock"></i>
                      </button>
                  </div>
                  <div v-if="su.blocked" class="text-white fs-5 mt-2">
                      <div>
                        This user is blocked, to release this user click on the button below.
                      </div>
                      <button class="btn btn-kraken fs-5 mt-2" @click="Processuser('release')" title="Release user." style="width: 25%;">
                        <i class="fa-solid fa-xl fa-lock-open"></i>
                      </button>
                  </div>
                </div>
              </div>
              <div class="col-md-9">
                <div class="p-1" >
                  <input class="btn bg-transparent text-white w-100 fs-2" value="Apps" type="text" v-if="false" readonly>
                  <div class="rounded" style="height: 574px; overflow-y: auto;">
                    <div v-for="(_app, _app_name, appi) in su.apps" :key="appi">
                      <div class="input-group flex-nowrap rounded border-bottom border-top border-end border-dark mt-1">
                        <button :title="capitalize(_app_name)" class="btn w-25 rounded bg-black" :class="{'app-icon-active': _app.access, 'app-icon-inactive': !_app.access}" @click="Setapp(_app)">
                          <img :src="require(`@/assets/logos/${_app_name}_logo.png`)" width="94">
                        </button>
                        <div class="input-group flex-nowrap p-2 w-100" style="overflow-x: auto; display: flex;" >
                          <button class="btn rounded fs-3 me-1" v-for="(_section, _sn, _si ) in _app.sections" :key="_si" :class="{'btn-kraken': _section, 'btn-dark': !_section}" :disabled="!_app.access" 
                          @click="_app.sections[_sn] = !_app.sections[_sn]">
                            {{titlelize(_sn)}}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
// Import the component with the line below.
//import Base from '@/components/Base.vue'

import axios from "axios";

export default {
  name: 'Users',
  components: {},
  data(){
    return {
      // General
      appclient: null,
      site: null,
      stage: null,
      section: 'restarea',
      processing: false,
      // Users
      users: [],
      gettingUsers: false,
      user: { username: null, email: null, apps: {} },
      su: { username: null, email: null, apps: {} },
      duser: { username: null, email:null, apps: {} },

      // New User
      newuser: null,
      newmail: null,




      action: "default",
      acting: false,
      actionMessage: "Select or add a user.",
      
      selected_user: null,

      // Add User
      addingUser: false,
      userApps: [],
      newUsername: "",
      newSuiteAccess: false,
      gettingAvailableApps: false,
      availableApps: [],

      // Edit User
      settingUser: false,
      processingUser: false,
      editableApps: []
    }
  },
  methods:{
    // Users
    getUsers(){
      this.actionMessage = "Getting users..."
      this.gettingUsers = true
      // New part
      this.clearMain()
      const params = {}
      const dest = this.site + '/suite/users/getUsers'
      axios
          .get(dest, {params})
          .then(rx => {
            // OK
            this.users = rx.data.users
            this.gettingUsers = false
            this.actionMessage = "Select or add a user."
          })
          .catch(error => {
              alert(error.response.data.error)
              //this.processErrorMessage(error)
              // Some Error.
              this.gettingUsers = false
      });
    },
    // User Main
    setUserMain(){
      // Empty
      this.su = this.cloneObject(this.user)
      if (this.user.username == null){
        this.section = 'restarea'
        return
      }
      this.section = 'main'
    },
    clearMain(){
      this.user = this.duser
      this.section = 'restarea'
      this.actionMessage = "Select or add a user."
    },
    // User Actions
    Saveuser(){
      this.section = 'restarea'
      this.actionMessage = 'Saving user changes: ' + this.su.username
      this.processing = true
      const params = { username: this.su.username, email: this.su.email, apps: this.su.apps }
      const dest = this.site + '/suite/users/saveUser'
      axios
        .post(dest, {params})
        .then(rx => {
          // OK
          alert(rx.data.message)
          this.newuser = null
          this.getUsers()
          this.processing = false
        })
        .catch(error => {
            this.processing = false
            this.processErrorMessage(error)
            this.setUserMain()
        });
    },
    Newuser(){
      // Execute the reset.
      this.section = 'restarea'
      this.actionMessage = 'Adding user: ' + this.newuser
      this.processing = true
      const params = { username: this.newuser, email: this.newmail }
      const dest = this.site + '/suite/users/newUser'
      axios
        .post(dest, {params})
        .then(rx => {
          // OK
          alert(rx.data.message)
          this.newuser = null
          this.newmail = null
          this.getUsers()
          this.processing = false
        })
        .catch(error => {
            this.processErrorMessage(error)
          // Some Error
          this.processing = false
          //this.getUsers()
        });
    },
    Deleteuser(){
      if (!confirm('Delete the selected user? | ' + this.su.username)){
        return
      }
      this.section = 'restarea'
      this.actionMessage = 'Deleting user: ' + this.su.username
      this.processing = true
      const params = { username: this.su.username }
      const dest = this.site + '/suite/users/deleteUser'
      axios
        .post(dest, {params})
        .then(rx => {
          // OK
          alert(rx.data.message)
          this.getUsers()
          this.clearMain()
          this.processing = false
        })
        .catch(error => {
            this.processErrorMessage(error)
          // Some Error
          this.processing = false
          this.getUsers()
        });
    },
    Resetsecret(){
      if (!confirm('Reset the password of the selected user? | ' + this.su.username)){
        return
      }
      this.section = 'restarea'
      this.actionMessage = 'Resetting user password: ' + this.su.username
      this.processing = true
      const params = { username: this.su.username,
                       reset: true}
      const dest = this.site + '/suite/users/alterPassword'
      axios
        .post(dest, {params})
        .then(rx => {
          // OK
          alert(rx.data.message)
          this.section = 'main'
          this.processing = false
        })
        .catch(error => {
            this.processErrorMessage(error)
          // Some Error
          this.section = 'main'
          this.processing = false
        });
    },
    Processuser(_mode){
      if (!confirm('Process the selected user? | ' + this.su.username)){
        return
      }
      this.actionMessage = `Processing user: "${this.su.username}" | ${this.capitalize(_mode)}`
      this.section = 'restarea'
      this.processing = true
      const params = { username: this.su.username, mode: _mode }
      const dest = this.site + '/suite/users/processUser'
      axios
        .post(dest, {params})
        .then(rx => {
          // OK
          alert(rx.data.message)
          this.getUsers()
          this.processing = false
        })
        .catch(error => {
            this.processErrorMessage(error)
            // Some Error
            this.processing = false
            this.clearMain()
        });
    },

    // Apps
    Setapp(app_element){
      app_element.access = !app_element.access
      if (!app_element.access){
        Object.keys(app_element.sections).forEach(v => app_element.sections[v] = false)
      }
    },
    // Errors
    processErrorMessage(error, mode="alert"){
        var err_message = null
        try {
            err_message = error.response.data.data.errorMessage
        } 
        catch (nerror) {
            try { 
                err_message = error.response.data.errorMessage
            } 
            catch (error) { 
                console.log(error) 
            }
        }
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
    return err_message
    },

    // -- Miscellaneous
    capitalize(_string){
        if (_string == null){return ""}
        const lower = String(_string).toLowerCase()
        return String(_string).charAt(0).toUpperCase() + lower.slice(1)
    },
    titlelize(_string){
      return _string.toLowerCase()
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join('-');
    },
    cloneObject(_object){
      return JSON.parse(JSON.stringify(_object))
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  created: function(){
    //this.appclient = localStorage.getItem('vrfaware_client')
    //this.site = this.site.replace('_CLIENT_NAME_', this.appclient)
    this.stage = process.env.NODE_ENV
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    // Setting
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
    this.getUsers()
  }
}
</script>

<style scoped>

  .border-suite{
    border-top: solid 2px rgb(0, 48, 90);
    border-bottom: solid 2px rgb(0, 48, 90);
    border-left: solid 2px rgb(0, 48, 90);
    border-right: solid 2px rgb(0, 48, 90);
  }

  .border-bottom-suite{
    border-bottom: solid 2px rgb(0, 48, 90);
  }

  .bg-suite{
    color: White;
    background-color: rgb(0, 48, 90);
    text-shadow: 3px 5px 4px Black;
  }

  .btn-suite{
    color: White;
    background-color: rgb(0, 48, 90);
    transition-duration: 0.5s;
    text-shadow: 3px 5px 4px Black;
    border-left: solid 6px transparent;
    border-right: solid 6px transparent;
  }
  .btn-suite:hover{
    color: rgb(0, 179, 255);
    background-color: rgb(1, 77, 144);
  }

  
  .app-icon-active{
    border-left: solid 8px rgb(1, 77, 144);
    border-right: solid 8px rgb(1, 77, 144);
    transition-duration: 0.7s;
    opacity: 1.0;
  }
  .app-icon-active:hover{
    opacity: 0.7;
  }
  .app-icon-inactive{
    border-left: solid 8px rgb(33, 33, 33);
    border-right: solid 8px rgb(33, 33, 33);
    transition-duration: 0.7s;
    opacity: 0.5;
    color: rgb(68, 68, 68);
  }
  .app-icon-inactive:hover{
    opacity: 0.7;
  }

  .bg-input{
      background-color: rgb(7,13,15);
      color: white;
  }

  .temporal-disable{
      opacity: 0.5;
      pointer-events: none;
  }


  .btn-kraken{
      background-color: rgb(20, 63, 162);
      color: white;
      transition-duration: 0.5s;
  }
  .btn-kraken:hover{
      background-color: rgb(0, 17, 39);
      color: rgb(0, 211, 249);
  }



  /* Scrollbar */
  /* width */
  ::-webkit-scrollbar {
      width: 10px;
      height: 7px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgb(37, 33, 33); 
      border-radius: 10px;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: rgb(64, 133, 88); 
      border-radius: 10px;
      transition-duration: 2.0s;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: rgb(54, 112, 75); 
  }

</style>
